<template>
    <div class="map-attr">
        <span class="map-attr-label">{{ value.label }}</span>
        <div class="map-attr-address">
            <i class="fal fa-map-marker-alt"></i>
            <span v-if="value.value.address">{{ value.value.address }}</span>
            <span v-else-if="value.value.lat && value.value.lon" class="map-attr-coords">
                {{ value.value.lat }}, {{ value.value.lon }}
            </span>
            <span v-else class="map-attr-empty">{{ $t('error.location.precision') }}</span>
        </div>
        <l-map v-if="value.value.lat && value.value.lon"
          id='myMap'
            ref="myMap"
            :zoom="zoom"
            :center="center"
            class="map-attr-map"
            @update:zoom="updateZoom($event)"
        >
            <l-tile-layer
                :attribution="attribution"
                :url="url"
                :options="optionsZoom"
            />
            <v-marker-cluster>
                <l-marker :lat-lng="coordinates">
                    <l-popup>
                        <PanelKanban
                            :post="post"
                            class="w-72 h-30"
                            :withStatus="true"
                        >
                        </PanelKanban>
                    </l-popup>
                </l-marker>
            </v-marker-cluster>
        </l-map>
    </div>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import { L, latLng, icon } from 'leaflet'
import {
  LMap,
  LTileLayer,
  LGeoJson,
  LPolygon,
  LMarker,
  LPopup,
  LIcon,
  LControl,
  LTooltip
} from 'vue2-leaflet'
import PanelKanban from '../../../components/UI/PanelKanban'

export default {
  name: 'MapPostCard',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    PanelKanban
  },
  props: ['post', 'value', 'isPostExport'],
  data: function() {
    return {
      preferCanvas: true,
      zoom: 16,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; OpenStreetMap contributors',
      optionsZoom: {
        maxZoom: 22,
        maxNativeZoom: 20
      }
    }
  },
  computed: {
    // The answer being rendered — NOT post.location, which the store overwrites
    // with the last location answer: a form holding both a "Localisation" and a
    // "Localisation BANOC" field would otherwise plot the same point twice,
    // under two different addresses.
    coordinates: function() {
      const location = this.value.value || {}
      return latLng(location.lat, location.lon)
    },
    center: function() {
      const location = this.value.value || {}
      return [location.lat, location.lon]
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.$refs.myMap && this.$refs.myMap.mapObject) {
          this.$refs.myMap.mapObject.invalidateSize()
        }
      }, 300)
    })
  },
  methods: {
    updateZoom: function(zoom) {
      this.zoom = zoom
    }
  }
}
</script>

<style scoped>
.map-attr-label {
    display: block;
    font-size: 0.72rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #94a3b8;
    margin-bottom: 6px;
}

.map-attr-address {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.9rem;
    color: #1e293b;
    margin-bottom: 12px;
}

.map-attr-address > i {
    color: #3b82f6;
    font-size: 0.95rem;
}

.map-attr-coords {
    color: #64748b;
    font-size: 0.82rem;
}

.map-attr-empty {
    color: #94a3b8;
    font-style: italic;
}

.map-attr-map {
    height: 220px;
    width: 100%;
    border-radius: 12px;
    z-index: 1;
    overflow: hidden;
}

@media (max-width: 900px) {
    .map-attr-map {
        height: 180px;
    }
}
</style>
